import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';
import AlternaModulos from 'components/AlternaModulos';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from 'constants/ActionTypes';
/* import ColorOption from 'containers/Customizer/ColorOption'; */
import { isIOS, isMobile } from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';
import { Fragment } from 'react';
import { fechaModulos, selecionaModulos, ativaTestes, selecionaPessoaSimulacao, executaSimulacao, userSignOutSuccess  } from 'actions/Auth';
import { irParaModulo } from 'actions/Setting';
import HeaderPortaria from '../components/HeaderPortaria/';

class App extends React.Component {

  ObtemRotasUsuario = (configuracao) => {
    var rotasAutorizadas = [];

    const ehEducar = this.props.moduloSelecionado === 'Educar';
    const ehDashboard = this.props.moduloSelecionado === 'Dashboard';
    const ehComunicacao = this.props.moduloSelecionado === 'Comunicação';

    var ehUzer = configuracao.uzerAcessoAmbienteCliente || configuracao.uzerAcessoPainelAdministrativo || configuracao.idPerfilSistema === 1;

    for (var indice in configuracao.menus) {
      var menu = configuracao.menus[indice];

      for (var indiceItem in menu.itensDoMenu) {
        var item = menu.itensDoMenu[indiceItem];

        const verificarAutorizacaoEducar = (item) => {
          const path = String(item.path || '').toLowerCase();
          const desc = String(item.descricaoItem || '').toLowerCase();

          const isEscolasItem = path === 'escolas' || desc === 'escolas';
          const isAlunosItem = path === 'alunos' || desc === 'alunos';
          const isCursosItem = path === 'cursos' || desc === 'cursos';
          const isSeriesItem = path === 'series' || desc === 'séries' || desc === 'series';
          const isTurmasItem = path === 'turmas' || desc === 'turmas';
          const isDisciplinasItem = path === 'disciplinas' || desc === 'disciplinas';
          const isSeriesEscolaItem = path === 'series-escola' || desc === 'séries escola' || desc === 'series escola';
          
          const isAtividadesPedagogicasItem = path === 'atividades-pedagogicas' || desc === 'atividades pedagógicas' || desc === 'atividades pedagogicas' || desc === 'atividades';
          const isCalendariosItem = path === 'calendarios' || desc === 'calendários' || desc === 'calendarios' || desc === 'calendário';
          const isDiarioItem = path === 'diario' || desc === 'diário' || desc === 'diário escolar';
          const isNotasFaltasItem = path === 'notas-faltas' || desc === 'notas e faltas' || desc === 'notas faltas';
          const isRegrasAvaliacaoItem = path === 'regras-avaliacao' || desc === 'regras de avaliação' || desc === 'regras avaliação';

          const isAnoLetivoItem = path === 'anos-letivos' || desc === 'ano letivo' || desc === 'anos letivos';
          const isMatriculasItem = path === 'matriculas' || desc === 'matrículas' || desc === 'matriculas';
          const isRematriculaItem = path === 'rematricula' || desc === 'rematrícula' || desc === 'rematriculas';
          const isEnturmacaoSequencialItem = path === 'enturmacao-sequencial' || desc === 'enturmação sequencial' || desc === 'enturmacao sequencial';

          const isBoletimItem = path === 'boletim' || desc === 'boletim';
          const isMapaConselhoItem = path === 'mapa-conselho-classe' || desc === 'mapa conselho' || desc === 'mapa de conselho';

          const isEducacensoItem = path === 'educacenso-exportacao' || desc === 'educacenso' || desc === 'exportação' || desc === 'exportacao';
          const isRelatorioMalaItem = path === 'relatorio-mala' || desc === 'relatório mala direta' || desc === 'relatorio mala direta';
          const isRelatorioLancamentoItem = path === 'relatorio-lancamento' || desc === 'relatório lançamento' || desc === 'relatorio lancamento';

          return isEscolasItem || isAlunosItem || isCursosItem || isSeriesItem || isTurmasItem || isDisciplinasItem || isSeriesEscolaItem ||
                 isAtividadesPedagogicasItem || isCalendariosItem || isDiarioItem || isNotasFaltasItem || isRegrasAvaliacaoItem ||
                 isAnoLetivoItem || isMatriculasItem || isRematriculaItem || isEnturmacaoSequencialItem ||
                 isBoletimItem || isMapaConselhoItem ||
                 isEducacensoItem || isRelatorioMalaItem || isRelatorioLancamentoItem;
        };

        const ehMenuDashboard = String(menu.descricaoMenu || '') === 'Dashboard';
        const ehMenuComunicacao = String(menu.descricaoMenu || '') === 'Comunicação';

        var autorizado = ehEducar
          ? verificarAutorizacaoEducar(item)
          : ehDashboard
            ? ehMenuDashboard
            : ehComunicacao
              ? ehMenuComunicacao
              : configuracao.listaConfiguracaoPortalFuncionalideAcao.filter(x => x.funcionalidadeAcaoUsuarioPortal.funcionalidadePortal.idItemMenu === item.id).length > 0;

        if (autorizado) {

          if (!ehUzer && item.descricaoItem === 'Clientes') {
            item.descricaoItem = 'Meu negócio';
            item.rota = 'routes/clientes/indexClienteFixo'
          }

          if (item.rota === 'routes/anos-letivos/index') {
            item.rota = 'routes/anoLetivo/index';
          }

          if (item.rota === 'routes/enturmacao-sequencial/index') {
            item.rota = 'routes/sequencia-enturmacao/index';
          }

          if (item.rota === 'routes/rematricula/index') {
            item.rota = 'routes/rematriculas/index';
          }

          const path = String(item.path || '').toLowerCase();
          const isNovoRelatorio = path === 'relatorio-usuarios-acessos' || path === 'relatorio-lancamento' || path === 'relatorio-matriculas' || path === 'relatorio-mala';
          const isNovoDocumento = path === 'mapa-conselho-classe' || path === 'ficha-aluno-branco';

          if (path === 'relatorio-lancamento') {
            item.rota = 'routes/relatorio-lancamento/index';
          } else if (path === 'relatorio-mala') {
            item.rota = 'routes/relatorio-mala/index';
          } else if (path === 'mapa-conselho-classe') {
            item.rota = 'routes/mapa-conselho-classe/index';
          } else if (path === 'boletim') {
            item.rota = 'routes/boletim/index';
          } else if (path === 'educacenso-exportacao') {
            item.rota = 'routes/educacenso/exportacao/index';
          } else if (isNovoRelatorio || isNovoDocumento) {
            item.rota = 'routes/construcao/index';
          }

          if (!rotasAutorizadas.some(r => r.path === item.path)) {
            rotasAutorizadas.push(item);
          }
        }
      }
    }

    return rotasAutorizadas;
  }

  render() {
    const { match, drawerType, navigationStyle, horizontalNavPosition, perfil, selecionarModulo, acessaBackOffice, acessaPortaria, configuracao, moduloSelecionado } = this.props;
    const selecionaModulo = selecionarModulo;
    const rotasAutorizadas = (configuracao !== undefined && Array.isArray(configuracao.menus)) ? this.ObtemRotasUsuario(configuracao) : [];
    const drawerStyle = selecionaModulo ? 'collapsible-drawer' : drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';
    console.log('sasa', moduloSelecionado)
    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    }
    else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }

    return (
      <div className={`app-container ${drawerStyle}`}>

        <Fragment>
          <Sidebar acessaPortaria={acessaPortaria} selecionaModulo={selecionaModulo} />
          <div className="app-main-container">

            <div
              className={`app-header ${navigationStyle === HORIZONTAL_NAVIGATION ? 'app-header-horizontal' : ''}`}>
              {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
                <TopNav styleName="app-top-header" />}

              <Header acessaPortaria={acessaPortaria} {...this.props} selecionaModulo={selecionaModulo} />

              {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
                <TopNav />}
            </div>

            <main className="app-main-content-wrapper">
              <div className="app-main-content">

                {
                  selecionaModulo || moduloSelecionado == "Cantina" || moduloSelecionado == "Diário Escolar" ?
                    <AlternaModulos {...this.props} exibeFechar={!this.props.loginRecente} funcaoFechar={() => { this.props.userSignOutSuccess(); }} /> :
                    <Switch>
                      <Route path={`${match.url}/inicio`} component={asyncComponent(() => import('./routes/inicio/index'))} />


                      <Route path={`${match.url}/escolas`} component={asyncComponent(() => import('./routes/escolas/index'))} />
                      <Route path={`${match.url}/alunos`} component={asyncComponent(() => import('./routes/alunos/index'))} />
                      <Route path={`${match.url}/cursos`} component={asyncComponent(() => import('./routes/cursos/index'))} />
                      <Route path={`${match.url}/series`} component={asyncComponent(() => import('./routes/series/index'))} />
                      <Route path={`${match.url}/disciplinas`} component={asyncComponent(() => import('./routes/disciplinas/index'))} />
                      <Route path={`${match.url}/turmas`} component={asyncComponent(() => import('./routes/turmas/index'))} />
                      <Route path={`${match.url}/matriculas`} component={asyncComponent(() => import('./routes/matriculas/index'))} />
                      <Route path={`${match.url}/calendarios`} component={asyncComponent(() => import('./routes/calendarios/index'))} />

                      <Route path={`${match.url}/anos-letivos`} component={asyncComponent(() => import('./routes/anoLetivo/index'))} />
                      <Route path={`${match.url}/enturmacao-sequencial`} component={asyncComponent(() => import('./routes/sequencia-enturmacao/index'))} />
                      <Route path={`${match.url}/rematricula`} component={asyncComponent(() => import('./routes/rematriculas/index'))} />

                      <Route path={`${match.url}/sequenciaEnturmacao`} component={asyncComponent(() => import('./routes/sequencia-enturmacao/index'))} />
                      <Route path={`${match.url}/rematriculas`} component={asyncComponent(() => import('./routes/rematriculas/index'))} />
                      <Route path={`${match.url}/series-escola`} component={asyncComponent(() => import('./routes/seriesEscola/index'))} />
                      <Route path={`${match.url}/regras-avaliacao`} component={asyncComponent(() => import('./routes/regrasAvaliacao/index'))} />
                      <Route path={`${match.url}/notas-faltas`} component={asyncComponent(() => import('./routes/notas-faltas/index'))} />
                      <Route path={`${match.url}/atividades-pedagogicas`} component={asyncComponent(() => import('./routes/atividades-pedagogicas/index'))} />
                      <Route path={`${match.url}/diario`} component={asyncComponent(() => import('./routes/diario/index'))} />
                      {
                        rotasAutorizadas.map(rota => {

                          return (
                            <Route key={`key${rota.id}`} path={`${match.url}/${rota.path}`} component={asyncComponent(() => import(`./${rota.rota}`))} />
                          )
                        })
                      }



                      {/*                         <Route path={`${match.url}/inicio`} component={asyncComponent(() => import('./routes/inicio/index'))} />
                        <Route path={`${match.url}/importar`} component={asyncComponent(() => import('./routes/construcao/index'))} />
                        <Route path={`${match.url}/equipamentos`} component={asyncComponent(() => import('./routes/equipamentos/index'))} />
                        <Route path={`${match.url}/usuariosPlataforma`} component={asyncComponent(() => import('./routes/usuariosPlataforma/index'))} />
                        <Route path={`${match.url}/usuariosPortal`} component={asyncComponent(() => import('./routes/usuariosPortal/index'))} />
                        <Route path={`${match.url}/dadosExternos`} component={asyncComponent(() => import('./routes/dadosExternos/index'))} />
                        <Route path={`${match.url}/modelos`} component={asyncComponent(() => import('./routes/modelos/index'))} />
                        <Route path={`${match.url}/clientes`} component={asyncComponent(() => import('./routes/clientes/index'))} />
                        <Route path={`${match.url}/locais`} component={asyncComponent(() => import('./routes/locaiQu/>
                        <Route path={`${match.url}/pontosAcesso`} component={asyncComponent(() => import('./routes/pontosAcesso/index'))} />
                        <Route path={`${match.url}/perfis`} component={asyncComponent(() => import('./routes/perfis/index'))} />
                        <Route path={`${match.url}/perfisPortal`} component={asyncComponent(() => import('./routes/perfisPortal/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/perfil`} component={asyncComponent(() => import('./routes/concessoesAcesso/perfil/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/genero`} component={asyncComponent(() => import('./routes/concessoesAcesso/genero/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/idade`} component={asyncComponent(() => import('./routes/concessoesAcesso/idade/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/periodo`} component={asyncComponent(() => import('./routes/concessoesAcesso/periodo/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/usuario`} component={asyncComponent(() => import('./routes/concessoesAcesso/usuario/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/full`} component={asyncComponent(() => import('./routes/concessoesAcesso/full/index'))} />
                        <Route path={`${match.url}/concessoesAcesso/bloqueio`} component={asyncComponent(() => import('./routes/concessoesAcesso/bloqueio/index'))} />
                        <Route path={`${match.url}/localidades`} component={asyncComponent(() => import('./routes/localidades/index'))} />
                        <Route path={`${match.url}/vinculosPessoa`} component={asyncComponent(() => import('./routes/vinculosPessoa/index'))} />
                        <Route path={`${match.url}/unidades`} component={asyncComponent(() => import('./routes/unidades/index'))} />
                        <Route path={`${match.url}/categorias`} component={asyncComponent(() => import('./routes/categorias/index'))} />
                        <Route path={`${match.url}/titularidades`} component={asyncComponent(() => import('./routes/titularidades/index'))} />
                        <Route path={`${match.url}/ambientes`} component={asyncComponent(() => import('./routes/ambientes/index'))} />
                        <Route path={`${match.url}/gestaoAcesso`} component={asyncComponent(() => import('./routes/gestaoAcesso/index'))} />
                        <Route path={`${match.url}/gestaoAcessoTemporario`} component={asyncComponent(() => import('./routes/gestaoAcessoTemporario/index'))} />
                        <Route path={`${match.url}/portaria/inicio`} component={asyncComponent(() => import('./portaria/index'))} /> */}
                    </Switch>
                }


              </div>
              <Footer />
            </main>
          </div>
        </Fragment>

      </div>
    );
  }
}


const mapStateToProps = ({ settings, auth }) => {
  const { drawerType, navigationStyle, horizontalNavPosition, configuracao, loginRecente, moduloSelecionado } = settings;
  const { perfil, selecionarModulo, acessaPortaria, acessaBackOffice } = auth
  return { drawerType, navigationStyle, horizontalNavPosition, perfil, selecionarModulo, acessaPortaria, acessaBackOffice, configuracao, loginRecente, moduloSelecionado }
};
export default withRouter(connect(mapStateToProps, { fechaModulos, selecionaModulos, ativaTestes, executaSimulacao, selecionaPessoaSimulacao, irParaModulo, userSignOutSuccess })(App));
